import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const UserEmailCircleIcon = (props: IconProps) => (
  <Icon width="33px" height="32px" viewBox="0 0 33 32" {...props}>
    <circle cx="16.2725" cy="16" r="16" fill="#6AB7C2" />
    <path
      fillRule="evenodd"
      d="M7.87253 7.4668H22.8059c1.0266 0 1.8666.84 1.8666 1.86666v4.66664h-1.8666v-2.8l-7.4667 4.6667-7.46667-4.6667v9.3334h9.33337v1.8666H7.87253c-1.02667 0-1.86667-.84-1.86667-1.8666l.00933-11.20004c0-1.02666.83067-1.86666 1.85734-1.86666Zm0 1.86666 7.46667 4.66664 7.4667-4.66664H7.87253Z"
      clipRule="evenodd"
    />
    <path d="M22.3394 21c1.4117 0 2.5667-1.155 2.5667-2.5666 0-1.4117-1.155-2.5667-2.5667-2.5667s-2.5667 1.155-2.5667 2.5667c0 1.4116 1.155 2.5666 2.5667 2.5666Zm5.1333 4.4019c0-1.0395-.616-1.9635-1.5656-2.3742-1.0909-.4748-2.2972-.7443-3.5677-.7443-1.2705 0-2.4768.2695-3.5677.7443-.9496.4107-1.5656 1.3347-1.5656 2.3742v.7315h10.2666v-.7315Z" />
  </Icon>
);

export default memo(UserEmailCircleIcon);
